import { UploadAdapter } from "./UploadAdapter";

export function UploadAdapterPlugin(editor: any) {
  editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) => {
    return new UploadAdapter(loader); // Replace with your upload URL
  };
}